module.exports = "/_next/static/images/reveal-light-03630f1c34a679e639cd853d44041f49.png";